<!-- 最小线宽/线距 -->
<template>
  <BaseFormItem
    :unit="fields.unit"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
    <img slot="other" :src="require('@@/assets/img/pcb/lineweight_view.jpg')" />
  </BaseFormItem>
</template>

<script>
import { getROGERSFields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: Number,
      default: 6
    },
    // 外层铜厚
    copper: {
      type: Number,
      default: 1
    },
    // 板子面积
    area: {
      type: [Number, String],
      default: ''
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getROGERSFields('lineweight')
    },
    options() {
      const { val, fields, copper, area } = this
      const options = fields.options
      // 最小限制
      let disabledOptions = []

      // 样板：0.5平米及以下 批量：0.5平米以上
      if (area > 0.5) {
        // 批量 禁用选项
        disabledOptions = {
          1: 4,
          2: 6,
          3: 7,
        }[copper]
      } else {
        // 样板 禁用选项
        disabledOptions = {
          1: 3.5,
          2: 5,
          3: 7,
        }[copper]
      }
      
      // 如果当前项被禁用
      if (val < disabledOptions) {
        // 选中对应的默认值
        this.changeVal({ 1: 6, 2: 6, 3: 8 }[copper])
      }
      
      return options.map(item => ({...item, disabled: item.value < disabledOptions }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
    },
    // 修改最小线宽/线距
    changeVal(val) {
      if (this.initPcbParamsChange) return
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>